import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/entities', { params });
  },
  create(data) {
    return axios.post('/v1/entities', data);
  },
  detail(id) {
    return axios.get(`/v1/entities/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/entities/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/entities/${id}`);
  }
};
